// @ts-ignore
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import styled from 'styled-components';

export const SearchBtnWrap = styled.button<{isInactive: boolean}>`
    width: 22px;
    height: 22px;
    padding: 0;
    background-color: transparent;
    border: none;
    cursor: ${p => p.isInactive ? 'auto' : 'pointer'};

    &:focus {
        outline: none;
    }
`;

export const SearchIcon = styled.svg<{isInactive: boolean}>`
    &>path {
        stroke: ${COLORS.middleGray};
    }

    &:hover {
        &>path {
            stroke: ${p => p.isInactive ? COLORS.middleGray : COLORS.black};
        }
    }
`;
